import * as React from 'react';
import { useTranslationHook } from 'PyzShopUi/scripts/utils/translationHook';

export interface Document {
    external_url_small: string;
    title: string;
}

export interface DocumentProps {
    safetyDataSheets?: Document[];
    certificates?: Document[];
    manuals?: Document[];
    sounds?: Document[];
    urls?: Document[];
}

export const Documents: React.FunctionComponent<DocumentProps> = props => {
    const { safetyDataSheets, certificates, manuals, sounds, urls } = props;
    const { translate } = useTranslationHook();

    React.useEffect(() => {
        const documentCount: number = safetyDataSheets.length + certificates.length + manuals.length + sounds.length + urls.length;
        const articleDocumentContentElement: HTMLElement = document.querySelector('.article-documents');
        const articleDocumentTabContent: HTMLElement = articleDocumentContentElement.parentElement;
        const articleDocumentTabHeader: Element = articleDocumentTabContent.previousElementSibling;
        const articleDocumentTabHeaderText: HTMLElement = articleDocumentTabContent.previousElementSibling.querySelector('.heading3');

        if (documentCount === 0) {
            articleDocumentTabContent.classList.add('hide');
            articleDocumentTabHeader.classList.add('hide');
            return;
        }

        articleDocumentTabContent.classList.remove('hide');
        articleDocumentTabHeader.classList.remove('hide');

        articleDocumentTabHeaderText
            .firstChild
            .textContent = `${translate('Documents', { ns: 'article-detail' })} (${documentCount})`;
    });

    return (
        <>
            {
                safetyDataSheets?.length ?
                    <>
                        <h4>{translate('Safety data sheets', { ns: 'article-detail' })}</h4>
                        <ul className="article-document-list">
                            {safetyDataSheets.map((safetyDataSheet, index) => {
                                    if (!safetyDataSheet.title) safetyDataSheet.title = translate('Safety data sheets', {ns: 'article-detail'});
                                    return (
                                        <li key={index}>
                                            <a target="_blank" href={safetyDataSheet.external_url_small} rel="noreferrer"
                                               title={safetyDataSheet.title}>
                                                <i className="icon icon-file-pdf"></i>
                                                {safetyDataSheet.title}
                                            </a>
                                        </li>
                                    );
                                }
                            )}
                        </ul>
                    </> : undefined
            }
            {
                certificates?.length ?
                    <>
                        <h4>{translate('Test certificates (TÜV, ABE, material)', { ns: 'article-detail' })}</h4>
                        <ul className="article-document-list">
                            {certificates.map((certificate, index) => {
                                if (!certificate.title) certificate.title = translate('Test certificates (TÜV, ABE, material)', {ns: 'article-detail'});
                                return (<li key={index}>
                                    <a target="_blank"
                                       href={certificate.external_url_small} rel="noreferrer"
                                       title={certificate.title}>
                                        <i className="icon icon-file-pdf"></i>
                                        {certificate.title}
                                    </a>
                                </li>);
                            })}
                        </ul>
                    </> : undefined
            }
            {
                manuals?.length ?
                    <>
                        <h4>{translate('Instructions/Guides', { ns: 'article-detail' })}</h4>
                        <ul className="article-document-list">
                            {manuals.map((manual, index) => {
                                if (!manual.title) manual.title = translate('Instructions/Guides', {ns: 'article-detail'});
                                return (
                                    <li key={index}>
                                        <a target="_blank"
                                           href={manual.external_url_small} rel="noreferrer"
                                           title={manual.title}>
                                            <i className="icon icon-file-pdf"></i>
                                            {manual.title}
                                        </a>
                                    </li>
                                );
                            })}
                        </ul>
                    </> : undefined
            }
            {
                sounds?.length ?
                    <>
                        <h4>{translate('Sounds', {ns: 'article-detail'})}</h4>
                        <ul className="article-document-list">
                            {sounds.map((sound, index) => {
                                if (!sound.title) sound.title = translate('Sounds', {ns: 'article-detail'});
                                return (<li key={index}>
                                    <a target="_blank"
                                       href={(sound.external_url_small).endsWith('.mp3') ? `${sound.external_url_small}` : `${sound.external_url_small}.mp3`}
                                       rel="noreferrer"
                                       title={sound.title}>
                                        <i className="icon icon-sound"></i>
                                        {sound.title}
                                    </a>
                                </li>);
                            })}
                        </ul>
                    </> : undefined
            }
            {
                urls?.length ?
                    <>
                        <h4>{translate('Links to product', {ns: 'article-detail'})}</h4>
                        <ul className="article-document-list">
                            {urls.map((url, index) => {
                                    if (!url.title) url.title = translate('Links to product', {ns: 'article-detail'});
                                    return (<li key={index}>
                                        <a target="_blank"
                                           href={url.external_url_small} rel="noreferrer"
                                           title={url.title}>
                                            <i className="icon icon-info"></i>
                                            {url.title}
                                        </a>
                                    </li>);
                                }
                            )}
                        </ul>
                    </> : undefined
            }
        </>
    );
}
